import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import "../style/sidebar.css";

import { useNavigate } from "react-router-dom";

import { BASE_URL } from "../utils/config";
import logo from '../images/Newestlogo.png';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import IconProfile from '../../src/images/profile-user-03.png';

const Sidebar = () => {


  const [Role, setRole] = useState(false);
  const [userdetails, setUserDetails] = useState(false);
  const [RenkoUser, setRenkoUser] = useState("");



  const navigate = useNavigate();
  useEffect(() => {

    const roleType = JSON.parse(localStorage.getItem('roleType'));
    const details = JSON.parse(localStorage.getItem('userdetails'));
    setUserDetails(details)
    setRenkoUser(details)
    console.log("roletypr", roleType);
    if (roleType === 'SuperAdmin') {
      setRole("SuperAdmin")
    } else if (roleType === 'Supervisor') {
      setRole("Supervisor")
    } else if (roleType === 'User') {
      setRole('User')
    } else {
      setRole('MCXUser')
    }
  }, []);




  const logout = async () => {

    let loginuser = JSON.parse(localStorage.getItem("loginData"));
    let body = JSON.stringify({ login_id: loginuser.login_id });
     await fetch(`${BASE_URL}/logout`, {
      method: "POST",
      body,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success === true) {
          localStorage.clear();

          setTimeout(() => {
            navigate("/login")
          }, 500);
        }else{
          alert( `Error: ${res.message}`)
        }
      })
      .catch(error =>{
       alert(`Error: ${error.message}`)
      })
  };




  const handleeditprofile = () => {

    let loginuser = JSON.parse(localStorage.getItem("userdetails"));

    navigate("/editprofile", {
      state: { userdetials: loginuser, edittype: "self" },
    });
  }

  return (
    <>
      <div className="main-nav">
        <Navbar expand="md" fixed="top">
          <Container fluid>
            <Navbar.Brand href="/home"><img className="logo" src={logo} alt="Logo"
              style={{ height: "60px", maxHeight: "100%", width: "auto", padding: "5px" }} /></Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
              <Nav
                className="me-auto my-2 my-lg-0 flex-grow-1 justify-content-center navlinks"
                style={{ maxHeight: '100px' }}
                navbarScroll
              >
                {Role === "SuperAdmin" ?
                  <>
                    <Nav.Link href="/userlist">User</Nav.Link>
                  </>
                  : null}

                {/* <Nav.Link href="/home">DashBoard</Nav.Link> */}
                {Role === "MCXUser" ? <Nav.Link href="/mcxdashboard">MCX Dashboard</Nav.Link> : null}

                {Role === "MCXUser" ? null : <NavDropdown title="DashBoard" id="create-report-dropdown">
                  <NavDropdown.Item href="/home">NSE Dashboard</NavDropdown.Item>
                  <NavDropdown.Item href="/mcxdashboard">MCX Dashboard</NavDropdown.Item>
                </NavDropdown>}

                {Role === "MCXUser" ? <Nav.Link href="/createmcxreport">Create</Nav.Link> : null}
                {Role === "MCXUser" ? null : <NavDropdown title="Create" id="create-report-dropdown">
                  <NavDropdown.Item href="/createreport">Create NSE Report</NavDropdown.Item>
                  {Role === "User" ?
                    null :
                    <>
                      <NavDropdown.Item href="/create-Index-IntraDay">Create Index/Intraday</NavDropdown.Item>

                    </>}

                  <NavDropdown.Item href="/createmcxreport">Create MCX Report</NavDropdown.Item>
                  <NavDropdown.Item href="/createreport360">Report Manual</NavDropdown.Item>
                </NavDropdown>}
                {/* <Nav.Link href="/createreport">Create Report</Nav.Link>
              <Nav.Link href="/createreport360">Report 360</Nav.Link> */}

                {Role === "MCXUser" ? <Nav.Link href="/performancemonitor">Performance Monitor</Nav.Link> : null}
                {Role === "MCXUser" ? null :
                  <NavDropdown title="Report" id="create-report-dropdown">
                    <NavDropdown.Item href="/viewreport">View Report</NavDropdown.Item>
                    {Role === "User" ?
                      null :
                      <>
                        <NavDropdown.Item href="/performancemonitor">Performance Monitor</NavDropdown.Item>

                        <NavDropdown.Item href="/HeartbeatMonitor">Heartbeat Monitor</NavDropdown.Item>

                      </>
                    }
                  </NavDropdown>}
                {/* <Nav.Link href="/viewreport">View Report</Nav.Link> */}

                {Role === "MCXUser" ? null :
                  <Nav.Link href="/commentry">Create Commentary</Nav.Link>
                  // <NavDropdown title="Commentary" id="create-report-dropdown">
                  // <NavDropdown.Item href="/commentry">Create Commentary</NavDropdown.Item>
                  // <NavDropdown.Item href="/sendcommentry">Send Commentary</NavDropdown.Item>
                  // </NavDropdown>
                }


                {RenkoUser.renko_access === 1 || RenkoUser.automate_renko_access === 1 ? (
                  <NavDropdown title="Renko" id="create-report-dropdown">
                    {RenkoUser.renko_access === 1 && (
                      <NavDropdown.Item href="/renkoview">View Renko</NavDropdown.Item>
                    )}
                    {RenkoUser.automate_renko_access === 1 && (
                      <NavDropdown.Item href="/automateRenko">Automate Renko</NavDropdown.Item>
                    )}
                  </NavDropdown>
                ) : null}



                <NavDropdown title="Script" id="create-report-dropdown">
                  <NavDropdown.Item href="/automatescriptrecord">Script Record</NavDropdown.Item>
                  <NavDropdown.Item href="/stocklevel">Script Level</NavDropdown.Item>
                  <NavDropdown.Item href="/stockInterval">Stock Interval</NavDropdown.Item>
                  <NavDropdown.Item href="/addGT">Add GT</NavDropdown.Item>
                  <NavDropdown.Item href="/addSR">Add SR</NavDropdown.Item>
                </NavDropdown>


              </Nav>

              <Nav className="d-flex">
                <span className="profile-picture">
                  <img src={IconProfile} alt="Profile" /></span>
                <div style={{ marginRight: "50px" }}>
                  <NavDropdown title={`${userdetails.first_name} ${userdetails.last_name}`} id="navbarScrollingDropdown" style={{ fontSize: "24px" }}>

                    <NavDropdown.Item href="/viewprofile">View</NavDropdown.Item>
                    <NavDropdown.Item onClick={handleeditprofile}>Edit</NavDropdown.Item>
                    <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>

                  </NavDropdown>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>


    </>
  );
};

export default Sidebar;
